/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../compat/compat.module';
import * as import2 from '@angular/common';
import * as import3 from 'ngx-cookie/src/cookie-options-provider';
import * as import4 from '../../app/@shared/auth/auth.service';
import * as import5 from '../../app/@shared/tracking/error-tracking.service';
import * as import6 from '../../app/@shared/tracking/custom-error-handler.service';
import * as import7 from '@angular/platform-browser';
import * as import8 from 'ngx-cookie/index';
import * as import9 from '@angular/http';
import * as import10 from '../../app/@shared/auth/auth.module';
import * as import11 from '../../app/@shared/tracking/tracking.module';
import * as import12 from '../../app/@shared/tracking/tracking.service';
import * as import13 from './compat-tracking.component.ngfactory';
import * as import14 from './compat-navigation.component.ngfactory';
import * as import15 from './compat-contact-list.component.ngfactory';
import * as import16 from './compat-chat.component.ngfactory';
import * as import17 from 'ngx-cookie/src/cookie.factory';
import * as import18 from '../../app/@shared/auth/auth.config';
import * as import19 from 'ngx-cookie/src/cookie.service';
import * as import20 from '../../app/@shared/tracking/tracking.config';
class CompatModuleInjector extends import0.ɵNgModuleInjector<import1.CompatModule> {
  _CommonModule_0:import2.CommonModule;
  _AUTH_CONFIG_1:any;
  _COOKIE_OPTIONS_2:any;
  _CookieOptionsProvider_3:import3.CookieOptionsProvider;
  _CookieService_4:any;
  _Auth_5:import4.Auth;
  _TRACKING_CONFIG_6:any;
  _ErrorTracking_7:import5.ErrorTracking;
  _ErrorHandler_8:import6.CustomErrorHandler;
  _APP_INITIALIZER_9:any[];
  _ApplicationInitStatus_10:import0.ApplicationInitStatus;
  _ɵf_11:import0.ɵf;
  _ApplicationRef_12:any;
  _ApplicationModule_13:import0.ApplicationModule;
  _BrowserModule_14:import7.BrowserModule;
  _CookieModule_15:import8.CookieModule;
  _HttpModule_16:import9.HttpModule;
  _AuthModule_17:import10.AuthModule;
  _TrackingModule_18:import11.TrackingModule;
  _CompatModule_19:import1.CompatModule;
  __LOCALE_ID_20:any;
  __NgLocalization_21:import2.NgLocaleLocalization;
  __Compiler_22:import0.Compiler;
  __APP_ID_23:any;
  __IterableDiffers_24:any;
  __KeyValueDiffers_25:any;
  __DomSanitizer_26:import7.ɵe;
  __Sanitizer_27:any;
  __HAMMER_GESTURE_CONFIG_28:import7.HammerGestureConfig;
  __EVENT_MANAGER_PLUGINS_29:any[];
  __EventManager_30:import7.EventManager;
  __ɵDomSharedStylesHost_31:import7.ɵDomSharedStylesHost;
  __ɵDomRendererFactory2_32:import7.ɵDomRendererFactory2;
  __RendererFactory2_33:any;
  __ɵSharedStylesHost_34:any;
  __Testability_35:import0.Testability;
  __Meta_36:import7.Meta;
  __Title_37:import7.Title;
  __BrowserXhr_38:import9.BrowserXhr;
  __ResponseOptions_39:import9.BaseResponseOptions;
  __XSRFStrategy_40:import11.NoXSRFStrategy;
  __XHRBackend_41:import9.XHRBackend;
  __RequestOptions_42:import9.BaseRequestOptions;
  __Http_43:any;
  __Tracking_44:import12.Tracking;
  constructor(parent:import0.Injector) {
    super(parent,[
      import13.CompatTrackingComponentNgFactory,
      import14.CompatNavigationComponentNgFactory,
      import15.CompatContactListComponentNgFactory,
      import16.CompatChatComponentNgFactory
    ]
    ,[
      import13.CompatTrackingComponentNgFactory,
      import14.CompatNavigationComponentNgFactory,
      import15.CompatContactListComponentNgFactory,
      import16.CompatChatComponentNgFactory
    ]
    );
  }
  get _LOCALE_ID_20():any {
    if ((this.__LOCALE_ID_20 == null)) { (this.__LOCALE_ID_20 = import0.ɵn(this.parent.get(import0.LOCALE_ID,(null as any)))); }
    return this.__LOCALE_ID_20;
  }
  get _NgLocalization_21():import2.NgLocaleLocalization {
    if ((this.__NgLocalization_21 == null)) { (this.__NgLocalization_21 = new import2.NgLocaleLocalization(this._LOCALE_ID_20)); }
    return this.__NgLocalization_21;
  }
  get _Compiler_22():import0.Compiler {
    if ((this.__Compiler_22 == null)) { (this.__Compiler_22 = new import0.Compiler()); }
    return this.__Compiler_22;
  }
  get _APP_ID_23():any {
    if ((this.__APP_ID_23 == null)) { (this.__APP_ID_23 = import0.ɵg()); }
    return this.__APP_ID_23;
  }
  get _IterableDiffers_24():any {
    if ((this.__IterableDiffers_24 == null)) { (this.__IterableDiffers_24 = import0.ɵl()); }
    return this.__IterableDiffers_24;
  }
  get _KeyValueDiffers_25():any {
    if ((this.__KeyValueDiffers_25 == null)) { (this.__KeyValueDiffers_25 = import0.ɵm()); }
    return this.__KeyValueDiffers_25;
  }
  get _DomSanitizer_26():import7.ɵe {
    if ((this.__DomSanitizer_26 == null)) { (this.__DomSanitizer_26 = new import7.ɵe(this.parent.get(import7.DOCUMENT))); }
    return this.__DomSanitizer_26;
  }
  get _Sanitizer_27():any {
    if ((this.__Sanitizer_27 == null)) { (this.__Sanitizer_27 = this._DomSanitizer_26); }
    return this.__Sanitizer_27;
  }
  get _HAMMER_GESTURE_CONFIG_28():import7.HammerGestureConfig {
    if ((this.__HAMMER_GESTURE_CONFIG_28 == null)) { (this.__HAMMER_GESTURE_CONFIG_28 = new import7.HammerGestureConfig()); }
    return this.__HAMMER_GESTURE_CONFIG_28;
  }
  get _EVENT_MANAGER_PLUGINS_29():any[] {
    if ((this.__EVENT_MANAGER_PLUGINS_29 == null)) { (this.__EVENT_MANAGER_PLUGINS_29 = [
      new import7.ɵDomEventsPlugin(this.parent.get(import7.DOCUMENT)),
      new import7.ɵKeyEventsPlugin(this.parent.get(import7.DOCUMENT)),
      new import7.ɵHammerGesturesPlugin(this.parent.get(import7.DOCUMENT),this._HAMMER_GESTURE_CONFIG_28)
    ]
    ); }
    return this.__EVENT_MANAGER_PLUGINS_29;
  }
  get _EventManager_30():import7.EventManager {
    if ((this.__EventManager_30 == null)) { (this.__EventManager_30 = new import7.EventManager(this._EVENT_MANAGER_PLUGINS_29,this.parent.get(import0.NgZone))); }
    return this.__EventManager_30;
  }
  get _ɵDomSharedStylesHost_31():import7.ɵDomSharedStylesHost {
    if ((this.__ɵDomSharedStylesHost_31 == null)) { (this.__ɵDomSharedStylesHost_31 = new import7.ɵDomSharedStylesHost(this.parent.get(import7.DOCUMENT))); }
    return this.__ɵDomSharedStylesHost_31;
  }
  get _ɵDomRendererFactory2_32():import7.ɵDomRendererFactory2 {
    if ((this.__ɵDomRendererFactory2_32 == null)) { (this.__ɵDomRendererFactory2_32 = new import7.ɵDomRendererFactory2(this._EventManager_30,this._ɵDomSharedStylesHost_31)); }
    return this.__ɵDomRendererFactory2_32;
  }
  get _RendererFactory2_33():any {
    if ((this.__RendererFactory2_33 == null)) { (this.__RendererFactory2_33 = this._ɵDomRendererFactory2_32); }
    return this.__RendererFactory2_33;
  }
  get _ɵSharedStylesHost_34():any {
    if ((this.__ɵSharedStylesHost_34 == null)) { (this.__ɵSharedStylesHost_34 = this._ɵDomSharedStylesHost_31); }
    return this.__ɵSharedStylesHost_34;
  }
  get _Testability_35():import0.Testability {
    if ((this.__Testability_35 == null)) { (this.__Testability_35 = new import0.Testability(this.parent.get(import0.NgZone))); }
    return this.__Testability_35;
  }
  get _Meta_36():import7.Meta {
    if ((this.__Meta_36 == null)) { (this.__Meta_36 = new import7.Meta(this.parent.get(import7.DOCUMENT))); }
    return this.__Meta_36;
  }
  get _Title_37():import7.Title {
    if ((this.__Title_37 == null)) { (this.__Title_37 = new import7.Title(this.parent.get(import7.DOCUMENT))); }
    return this.__Title_37;
  }
  get _BrowserXhr_38():import9.BrowserXhr {
    if ((this.__BrowserXhr_38 == null)) { (this.__BrowserXhr_38 = new import9.BrowserXhr()); }
    return this.__BrowserXhr_38;
  }
  get _ResponseOptions_39():import9.BaseResponseOptions {
    if ((this.__ResponseOptions_39 == null)) { (this.__ResponseOptions_39 = new import9.BaseResponseOptions()); }
    return this.__ResponseOptions_39;
  }
  get _XSRFStrategy_40():import11.NoXSRFStrategy {
    if ((this.__XSRFStrategy_40 == null)) { (this.__XSRFStrategy_40 = new import11.NoXSRFStrategy()); }
    return this.__XSRFStrategy_40;
  }
  get _XHRBackend_41():import9.XHRBackend {
    if ((this.__XHRBackend_41 == null)) { (this.__XHRBackend_41 = new import9.XHRBackend(this._BrowserXhr_38,this._ResponseOptions_39,this._XSRFStrategy_40)); }
    return this.__XHRBackend_41;
  }
  get _RequestOptions_42():import9.BaseRequestOptions {
    if ((this.__RequestOptions_42 == null)) { (this.__RequestOptions_42 = new import9.BaseRequestOptions()); }
    return this.__RequestOptions_42;
  }
  get _Http_43():any {
    if ((this.__Http_43 == null)) { (this.__Http_43 = import9.ɵc(this._XHRBackend_41,this._RequestOptions_42)); }
    return this.__Http_43;
  }
  get _Tracking_44():import12.Tracking {
    if ((this.__Tracking_44 == null)) { (this.__Tracking_44 = new import12.Tracking(this._Http_43,this._Auth_5,this._CookieService_4,this._TRACKING_CONFIG_6)); }
    return this.__Tracking_44;
  }
  createInternal():import1.CompatModule {
    this._CommonModule_0 = new import2.CommonModule();
    this._AUTH_CONFIG_1 = {
      baseUrl: 'https://www.freelancer.com/auth',
      authHashCookie: 'GETAFREE_AUTH_HASH_V2',
      userIdCookie: 'GETAFREE_USER_ID'
    }
    ;
    this._COOKIE_OPTIONS_2 = {};
    this._CookieOptionsProvider_3 = new import3.CookieOptionsProvider(this._COOKIE_OPTIONS_2,this);
    this._CookieService_4 = import17.cookieServiceFactory(this._CookieOptionsProvider_3);
    this._Auth_5 = new import4.Auth(this._AUTH_CONFIG_1,this._CookieService_4);
    this._TRACKING_CONFIG_6 = {
      trackingEndpoint: 'https://t.freelancer.com/0px.gif',
      sessionCookie: '_tracking_session',
      navigationPerformanceSamplingRate: 1,
      enableErrorTracking: true,
      sentryDsn: 'https://89961363a0f642558f5fedad5195eb89@sentry.io/85230',
      gitRevision: '425b66ab2e6',
      buildDate: 'Tue May 30 2017 22:39:13 GMT-0400 (EDT)'
    }
    ;
    this._ErrorTracking_7 = new import5.ErrorTracking(this._Auth_5,this._TRACKING_CONFIG_6);
    this._ErrorHandler_8 = new import6.CustomErrorHandler(this._ErrorTracking_7);
    this._APP_INITIALIZER_9 = [
      import0.ɵo,
      import7.ɵc(this.parent.get(import7.NgProbeToken,(null as any)),this.parent.get(import0.NgProbeToken,(null as any)))
    ]
    ;
    this._ApplicationInitStatus_10 = new import0.ApplicationInitStatus(this._APP_INITIALIZER_9);
    this._ɵf_11 = new import0.ɵf(this.parent.get(import0.NgZone),this.parent.get(import0.ɵConsole),this,this._ErrorHandler_8,this.componentFactoryResolver,this._ApplicationInitStatus_10);
    this._ApplicationRef_12 = this._ɵf_11;
    this._ApplicationModule_13 = new import0.ApplicationModule(this._ApplicationRef_12);
    this._BrowserModule_14 = new import7.BrowserModule(this.parent.get(import7.BrowserModule,(null as any)));
    this._CookieModule_15 = new import8.CookieModule();
    this._HttpModule_16 = new import9.HttpModule();
    this._AuthModule_17 = new import10.AuthModule();
    this._TrackingModule_18 = new import11.TrackingModule();
    this._CompatModule_19 = new import1.CompatModule();
    return this._CompatModule_19;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.CommonModule)) { return this._CommonModule_0; }
    if ((token === import18.AUTH_CONFIG)) { return this._AUTH_CONFIG_1; }
    if ((token === import3.COOKIE_OPTIONS)) { return this._COOKIE_OPTIONS_2; }
    if ((token === import3.CookieOptionsProvider)) { return this._CookieOptionsProvider_3; }
    if ((token === import19.CookieService)) { return this._CookieService_4; }
    if ((token === import4.Auth)) { return this._Auth_5; }
    if ((token === import20.TRACKING_CONFIG)) { return this._TRACKING_CONFIG_6; }
    if ((token === import5.ErrorTracking)) { return this._ErrorTracking_7; }
    if ((token === import0.ErrorHandler)) { return this._ErrorHandler_8; }
    if ((token === import0.APP_INITIALIZER)) { return this._APP_INITIALIZER_9; }
    if ((token === import0.ApplicationInitStatus)) { return this._ApplicationInitStatus_10; }
    if ((token === import0.ɵf)) { return this._ɵf_11; }
    if ((token === import0.ApplicationRef)) { return this._ApplicationRef_12; }
    if ((token === import0.ApplicationModule)) { return this._ApplicationModule_13; }
    if ((token === import7.BrowserModule)) { return this._BrowserModule_14; }
    if ((token === import8.CookieModule)) { return this._CookieModule_15; }
    if ((token === import9.HttpModule)) { return this._HttpModule_16; }
    if ((token === import10.AuthModule)) { return this._AuthModule_17; }
    if ((token === import11.TrackingModule)) { return this._TrackingModule_18; }
    if ((token === import1.CompatModule)) { return this._CompatModule_19; }
    if ((token === import0.LOCALE_ID)) { return this._LOCALE_ID_20; }
    if ((token === import2.NgLocalization)) { return this._NgLocalization_21; }
    if ((token === import0.Compiler)) { return this._Compiler_22; }
    if ((token === import0.APP_ID)) { return this._APP_ID_23; }
    if ((token === import0.IterableDiffers)) { return this._IterableDiffers_24; }
    if ((token === import0.KeyValueDiffers)) { return this._KeyValueDiffers_25; }
    if ((token === import7.DomSanitizer)) { return this._DomSanitizer_26; }
    if ((token === import0.Sanitizer)) { return this._Sanitizer_27; }
    if ((token === import7.HAMMER_GESTURE_CONFIG)) { return this._HAMMER_GESTURE_CONFIG_28; }
    if ((token === import7.EVENT_MANAGER_PLUGINS)) { return this._EVENT_MANAGER_PLUGINS_29; }
    if ((token === import7.EventManager)) { return this._EventManager_30; }
    if ((token === import7.ɵDomSharedStylesHost)) { return this._ɵDomSharedStylesHost_31; }
    if ((token === import7.ɵDomRendererFactory2)) { return this._ɵDomRendererFactory2_32; }
    if ((token === import0.RendererFactory2)) { return this._RendererFactory2_33; }
    if ((token === import7.ɵSharedStylesHost)) { return this._ɵSharedStylesHost_34; }
    if ((token === import0.Testability)) { return this._Testability_35; }
    if ((token === import7.Meta)) { return this._Meta_36; }
    if ((token === import7.Title)) { return this._Title_37; }
    if ((token === import9.BrowserXhr)) { return this._BrowserXhr_38; }
    if ((token === import9.ResponseOptions)) { return this._ResponseOptions_39; }
    if ((token === import9.XSRFStrategy)) { return this._XSRFStrategy_40; }
    if ((token === import9.XHRBackend)) { return this._XHRBackend_41; }
    if ((token === import9.RequestOptions)) { return this._RequestOptions_42; }
    if ((token === import9.Http)) { return this._Http_43; }
    if ((token === import12.Tracking)) { return this._Tracking_44; }
    return notFoundResult;
  }
  destroyInternal():void {
    this._ɵf_11.ngOnDestroy();
    (this.__ɵDomSharedStylesHost_31 && this._ɵDomSharedStylesHost_31.ngOnDestroy());
  }
}
export const CompatModuleNgFactory:import0.NgModuleFactory<import1.CompatModule> = new import0.NgModuleFactory<any>(CompatModuleInjector,import1.CompatModule);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0Lm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/compat/compat.module.ngfactory.ts